<template>
  <div class="number_continer">
    <template v-if="type == 1">
      <img src="../assets/image/new_img/number_bg_02.png" alt="">
      <span>已有{{bigRegisteredCount}}人报名</span>
    </template>

    <template v-else-if="type == 2 || type == 3">
      <img src="../assets/image/new_img/number_bg_01.png" alt="">
      <span>已有{{bigRegisteredCount}}人报名</span>
    </template>

    <template v-else-if="type == 5">
      <div class="number_continer">
        <img src="../assets/image/new_img/number_bg_03.png" alt="">
        <span>已有{{registeredCount}}人报名</span>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
  export default {
    name: "registNumber",
    props: {
      type: {
        default: 1
      },
    },
    computed: {
      ...mapGetters({
        bigRegisteredCount: 'ticketStore/getBigRegisteredCount',
        registeredCount: 'ticketStore/getRegisteredCount',
      }),
    },
    created(){
      this.$store.dispatch('ticketStore/initializeTicketSystem');
    },
    destroyed(){
      this.$store.commit('ticketStore/cleanupTimers');
    }
  }
</script>

<style scoped>

</style>